export const randNumber = (min = 10, max = 100): number => {
  const randomNum = Math.random() * (max - min) + min;
  return Math.floor(randomNum);
};
